import { error } from "jquery";

(function () {
    const CLASS_SHOW_DROPDOWN = 'show-dropdown';
    const CLASS_SELECTED = 'selected';

    let searchBar: HTMLInputElement;
    let dropdown: HTMLUListElement;
    let selectedElement: HTMLLIElement;

    let searchContainer: HTMLElement;
    let openSearchButton: HTMLButtonElement;
    let closeSearchButton: HTMLButtonElement;

    function handleLIClick(e: MouseEvent) {
        if (dropdown.classList.contains(CLASS_SHOW_DROPDOWN)) {
            selectedElement = e.target as HTMLLIElement;
            selectedElement.classList.add(CLASS_SELECTED);
            dropdown.classList.remove(CLASS_SHOW_DROPDOWN);
            searchBar.focus();
        } else {
            dropdown.classList.add(CLASS_SHOW_DROPDOWN)
            if (selectedElement) {
                selectedElement.classList.remove(CLASS_SELECTED);
            }
        }
    }

    function handleSearch() {
        const query = searchBar.value;
        let path = selectedElement.dataset.searchpath;
        if (!path) {
            console.error('Search path has not been set in custom settings module')
            return;
        }
        path = path.replace('[QUERY]', encodeURI(query));
        window.location.href = path;
    }

    function trimStartOfChar(str: string, char: string) {
        if (!str || str.length === 0 || !char || char.length === 0 || str.length < char.length) {
            return str;
        }

        while (str.startsWith(char)) {
            str = str.slice(char.length);
        }

        return str;
    }

    $(() => {
        searchBar = document.getElementById('mainSearchBar') as HTMLInputElement
        dropdown = document.querySelector('.search-type-dropdown') as HTMLUListElement;
        selectedElement = dropdown.querySelector(`li.${CLASS_SELECTED}`);

        searchContainer = document.querySelector('.header-actions') as HTMLElement;
        openSearchButton = searchContainer.querySelector('.action-button-container [toggle-class="show-search"][toggle-class-target=".header-actions"]') as HTMLButtonElement;
        closeSearchButton = searchContainer.querySelector('.search-container .btn[toggle-class="show-search"][toggle-class-target=".header-actions"]') as HTMLButtonElement;

        if (!searchBar) {
            error('Search bar not found');
            return;
        }

        if (dropdown) {
            const firstSegmentOfCurrentUrl = trimStartOfChar(window.location.pathname, '/')?.split('?')[0].split('/')[0].toLowerCase();

            dropdown.querySelectorAll('li').forEach(li => {
                const firstSegmentOfLi = trimStartOfChar(li.getAttribute('data-searchpath'), '/')?.split('?')[0].split('/')[0].toLowerCase();

                if (firstSegmentOfCurrentUrl === firstSegmentOfLi) {
                    if (!li.classList.contains(CLASS_SELECTED)) {
                        li.classList.add(CLASS_SELECTED);
                    }

                    selectedElement = li;
                }

                li.addEventListener('click', handleLIClick);
            });

            if (!selectedElement) {
                if (dropdown.childElementCount > 2) {
                    selectedElement = dropdown.children[2] as HTMLLIElement;
                }
                else {
                    selectedElement = dropdown.firstElementChild as HTMLLIElement;
                }

                selectedElement.classList.add(CLASS_SELECTED);
            }
        }

        searchBar.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                handleSearch();
            }
            else if (e.key === 'Escape') {
                if (closeSearchButton) {
                    closeSearchButton.click();
                }
            }
        });

        openSearchButton.addEventListener('click', _ => {
            if (!searchContainer.className.includes('show-search')) {
                searchBar.focus();
            }
        })
    });
})()
